var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pull-to',{staticClass:"eds-privacy"},[_c('div',{staticClass:"privacy"},[_vm._v(_vm._s(_vm.privacy))])])
}
var staticRenderFns = []

export { render, staticRenderFns }